// Copyright (c) Move Closer 2022.

import { AnyObject } from '@movecloser/front-core'
import snakeCase from 'lodash/snakeCase'
import { TranslateResult } from 'vue-i18n'

import { ValidationMessages, ValidationRules } from '../molecules/Form'

import { messagesEN, messagesPL } from '../services/validator/locales'
import { IValidationFormField, setMessageHandlers, validateForm, ValidationResult } from '../services/validator'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
function composePayload (
  payload: AnyObject,
  validatorsMap: ValidationRules,
  locale: string,
  translate: (key: string) => TranslateResult
): Record<string, IValidationFormField> {
  const validationPayload: Record<string, IValidationFormField> = {}

  for (const [key, rules] of Object.entries(validatorsMap)) {
    if (!(key in payload)) {
      continue
    }

    const attribute: string = locale !== 'en'
      ? translate(`attributes.${key}`).toString() : snakeCase(key).replace('_', ' ')

    validationPayload[key] = {
      name: attribute,
      value: payload[key],
      validation: Array.isArray(rules) ? rules.join('|') : rules
    }
  }

  return validationPayload
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
function setMessages (locale: string): void {
  let messages: ValidationMessages
  switch (locale.toLowerCase()) {
    case 'pl':
      messages = messagesPL
      break
    default:
      messages = messagesEN
  }

  setMessageHandlers(messages)
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function validatePayload (
  payload: AnyObject,
  validatorsMap: ValidationRules,
  translate: (key: string) => TranslateResult,
  locale: string = 'pl'
): ValidationResult {
  const validationPayload = composePayload(payload, validatorsMap, locale, translate)

  setMessages(locale)

  return validateForm({ formData: validationPayload })
}
